import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  MedicineBoxOutlined,
  TruckOutlined,
} from '@ant-design/icons';

import i18n from 'utils/i18n';

const { t } = i18n.i18n;

export const STATUS_FILTER_OPTIONS = [
  {
    label: t('packageTrackerDashboard.packageStatus.shipping'),
    value: 'shipped',
  },
  {
    label: t('packageTrackerDashboard.packageStatus.delivered'),
    value: 'delivered',
  },
  {
    label: t('packageTrackerDashboard.packageStatus.invoiceUploaded'),
    value: 'fulfilled',
  },
];

export const SHIPMENT_STATUS_FILTER_OPTIONS = [
  {
    label: t('packageTrackerDashboard.shipmentStatus.shipped'),
    value: 'SHIPPED',
  },
  {
    label: t('packageTrackerDashboard.shipmentStatus.invoiced'),
    value: 'INVOICED',
  },
  {
    label: t('packageTrackerDashboard.shipmentStatus.partiallyShipped'),
    value: 'PARTIALLY_SHIPPED',
  },
];

export const statusMap = {
  shipped: {
    label: t('packageTrackerDashboard.packageStatus.shipping'),
    colors: {
      bg: '#FFFAE6',
      text: '#C90',
    },
    icon: <TruckOutlined />,
  },

  delivered: {
    label: t('packageTrackerDashboard.packageStatus.delivered'),
    colors: {
      bg: '#E5F2FF',
      text: '#0958D9',
    },
    icon: <MedicineBoxOutlined />,
  },
  fulfilled: {
    label: t('packageTrackerDashboard.packageStatus.invoiceUploaded'),
    colors: {
      bg: '#EBF3E8',
      text: '#318507',
    },
    icon: <CheckCircleOutlined />,
  },
};

export const shipmentStatusMap = {
  shipped: {
    label: t('packageTrackerDashboard.shipmentStatus.shipped'),
    icon: null,
    tooltip: null,
  },
  invoiced: {
    label: t('packageTrackerDashboard.shipmentStatus.invoiced'),
    icon: null,
    tooltip: null,
  },
  partially_shipped: {
    label: t('packageTrackerDashboard.shipmentStatus.partiallyShipped'),
    icon: <ExclamationCircleOutlined style={{ color: 'blue' }} />,
    tooltip: t('packageTrackerDashboard.tooltips.partiallyShipped'),
  },
  draft: {
    label: t('packageTrackerDashboard.shipmentStatus.draft'),
    icon: null,
    tooltip: null,
  },
  confirmed: {
    label: t('packageTrackerDashboard.shipmentStatus.confirmed'),
    icon: null,
    tooltip: null,
  },
  fulfilled: {
    label: t('packageTrackerDashboard.shipmentStatus.fulfilled'),
    icon: null,
    tooltip: null,
  },
};
